<template>
  <CustomButton
    v-if="show"
    type="raw"
    class="ml-4 mb-4 text-sm flex justify-start"
    :text="$t('Need support?')"
    @click="onClick"
  >
    <template #icon-left>
      <i class="iconify svg--info text-EXPONDO-secondary top-0.5 pr-1" />
    </template>
  </CustomButton>
</template>

<script lang="ts">

export default defineComponent({
  name: 'VatIdNeedSupport',

  props: {
    show: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['click'],
  setup(_props, { emit }) {

    const onClick = () => {

      emit('click');
    
    };

    return {
      onClick,
    };
  
  },
});

</script>

<style lang="scss" scoped>
.button-base {
  :deep(span) {
    @apply text-EXPONDO-secondary underline;
  }
}
</style>
